import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap gap-2 rounded text-sm font-semibold tracking-wide transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-canvas disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "border border-primary bg-primary text-primary-fg hover:bg-primary-strong hover:shadow-glow",
        destructive:
          "border border-danger/50 bg-danger/10 text-danger hover:bg-danger/20",
        outline:
          "border border-line bg-transparent text-fg hover:border-primary/60 hover:text-primary",
        secondary:
          "border border-line bg-surface text-fg hover:border-primary/40 hover:bg-elevated",
        ghost: "text-fg-muted hover:bg-primary/10 hover:text-fg",
        link: "text-primary underline-offset-4 hover:underline",
        accent:
          "border border-accent bg-accent text-accent-fg hover:bg-accent-strong hover:shadow-glow-accent",
      },
      size: {
        default: "h-10 px-5",
        sm: "h-8 px-3 text-xs",
        lg: "h-12 px-8 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
